import Row from 'blocks/Row';
import { getAlphabetDate, getTime } from 'helper/date';
import { useTranslation } from 'react-i18next';
import { RouteDetailProps } from './routeDetail.interface';
import * as S from './routeDetail.styles';

const RouteDetail = ({ flight, showPNR }: RouteDetailProps) => {
  if (!flight) return null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();
  return (
    <S.RouteDetail>
      <Row justify="space-between">
        <S.Name1>
          {flight.fname} {flight.lname}
        </S.Name1>
        {showPNR && (
          <S.Name2>
            {t('pages.miles.claim.sections.flightRecords.modals.flightDetails.airlinePNR')} {flight.PNR}
          </S.Name2>
        )}
      </Row>

      <S.TextBlue>
        {t('pages.miles.claim.sections.flightRecords.modals.flightDetails.flightTo')} {flight.destination}{' '}
        {flight.RDB ? `(${flight.RDB})` : ''}
      </S.TextBlue>

      <div className="route">
        <S.Form>
          <S.Bullet>
            <S.BulletSpan></S.BulletSpan>
          </S.Bullet>
          <S.FormInfo>
            <S.FlightFlightDate>
              {getAlphabetDate(flight.flightDate)} . {getTime(flight.flightDate, 0)}
            </S.FlightFlightDate>
            <S.FlightDeparture>{flight.departure}</S.FlightDeparture>
          </S.FormInfo>
        </S.Form>

        <S.To>
          <S.Bullet>
            <S.BulletSpan2></S.BulletSpan2>
          </S.Bullet>
          <S.FlightFlightToInfo>
            <S.FlightFlightDate>
              {getAlphabetDate(flight.landingDate)} . {getTime(flight.landingDate, 0)}
            </S.FlightFlightDate>
            <S.FlightDeparture>{flight.destination}</S.FlightDeparture>
          </S.FlightFlightToInfo>
        </S.To>
      </div>
    </S.RouteDetail>
  );
};

export default RouteDetail;
